import {Injectable} from '@angular/core';
import {SiteInfo} from '../models';
import {IoService} from './io.service';

@Injectable()
export class SiteInfoService extends IoService {
  protected model = SiteInfo;
  protected listUrl = '/siteinfo/';
}
